import type { ReactNode } from 'react';

export const symbol_cloud_lock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M478-371ZM250-160q-86 0-148-62T40-370q0-78 49.5-137.5T217-579q20-97 94-158.5T482-799q103 0 177 69t87 170q2 15-6.5 23T720-527q-11 2-21.5-4.5T686-553q-11-78-69-132t-139-54q-89 0-150 64t-61 153h-19q-62 0-105 43.5T100-371q0 62 43.93 106.5T250-220h310q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H250Zm435 0q-14 0-24.5-10.5T650-195v-120q0-14 11.5-24.5T690-350v-45q0-30.94 22.04-52.97 22.05-22.03 53-22.03Q796-470 818-447.97T840-395v45q17 0 28.5 10.5T880-315v120q0 14-10.5 24.5T845-160H685Zm35-190h90v-44.91Q810-414 797.09-427q-12.91-13-32-13T733-427.06q-13 12.93-13 32.06v45Z"
		/>
	</svg>
);
